import React from 'react'
import { Link } from 'react-router-dom'

function parseResult (result) {
  const parsed = {
    href: `/${result.slug}`,
    image: result.fields.hero_image ? result.fields.hero_image.value.thumbnail[0] : 'https://dummyimage.com/150x150/0000ff/00f.jpg',
    subtitle: false
  }

  switch (result.type) {
    case 'page':
      if (result.fields.group_page_settings) {
        parsed.image = result.fields.group_page_settings.value[0].hero_image.value[0].thumbnail[0]
      }
      break
    case 'project':
      parsed.href = `/projects/${result.slug}`
      parsed.subtitle = result.fields.main_subtitle.value
      break
    case 'job_opening':
      parsed.href = `/careers/${result.slug}`
      break
    case 'journal_article':
      parsed.image = result.fields.journal.value[0].hero_image.value.thumbnail[0]
      parsed.href = `/journal/${result.slug}`
      break
    default:
      break
  }

  return parsed
}

const Results = (props) => {
  const results = props.results.map((result, idx) => {
    const data = parseResult(result)
    const href = data.href
    const subtitle = data.subtitle ? <span>{data.subtitle}</span> : false

    return (
      <li
        key={idx}
        onClick={props.onNav}>
        <Link to={href} className='search__result'>
          <span className='search__result-image'>
            <img src={data.image} alt={result.title} />
          </span>
          <div>
            <h3>{result.title}</h3>
            {subtitle}
          </div>
        </Link>
      </li>
    )
  })

  return (
    <ul className='search__results'>
      {results}
    </ul>
  )
}

export default Results



// WEBPACK FOOTER //
// ./src/components/Header/Search/Results/index.js